
import { QueryClient } from '@tanstack/react-query';
import { cacheManager } from '@/utils/cacheManager';

// Create a client
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60 * 1000, // 1 minute
      retry: 1,
      refetchOnWindowFocus: false,
    },
  },
});

// Set the query client in the cache manager
cacheManager.setQueryClient(queryClient);
